import type { CartDetailsResponse } from 'src/api/endpoints/storeApi.types';

import { addDays } from 'date-fns';
import { formatDate } from './formatDate';
import { formatAmount } from './productUtils';

function getPriceWithTaxFormatted(
  cartDetails?: CartDetailsResponse,
  locale?: string
) {
  return formatAmount(
    cartDetails?.data?.productPrice.total ?? 0,
    cartDetails?.data?.currency,
    locale
  );
}

function getPriceWithoutTaxFormatted(
  cartDetails?: CartDetailsResponse,
  locale?: string
) {
  return formatAmount(
    cartDetails?.data?.productPrice.base ?? 0,
    cartDetails?.data?.currency,
    locale
  );
}

function getTaxFormatted(cartDetails?: CartDetailsResponse, locale?: string) {
  return formatAmount(
    cartDetails?.data?.productPrice.tax ?? 0,
    cartDetails?.data?.currency,
    locale
  );
}

function isTaxIncluded(cartDetails?: CartDetailsResponse) {
  return cartDetails?.data?.tax.isIncluded;
}

function getProductName(cartDetails?: CartDetailsResponse) {
  return cartDetails?.data?.product.name;
}

function formatBillingStartDate(
  cartDetails?: CartDetailsResponse,
  locale?: string
) {
  return formatDate(
    cartDetails?.data.freeTrialLengthDays
      ? addDays(new Date(), cartDetails?.data.freeTrialLengthDays)
      : '',
    { locale }
  );
}

export const cartHelpers = {
  getPriceWithTaxFormatted,
  getPriceWithoutTaxFormatted,
  getTaxFormatted,
  getProductName,
  isTaxIncluded,
  formatBillingStartDate,
};
